<script>
  import Breadcrumbs from '$components/Breadcrumbs/Breadcrumbs.svelte';
  import MastheadSearchPromo from '$components/MastheadSearchPromo/MastheadSearchPromo.svelte';
  import LocationLinkList from '$components/LocationLinkList/LocationLinkList.svelte';
  import DrugSavingsList from '$components/DrugSavingsList/DrugSavingsList.svelte';
  import ExtendedPharmaciesList from '$components/ExtendedPharmaciesList/ExtendedPharmaciesList.svelte';

  let { data } = $props();
</script>

<svelte:head>
  {#if data.locationLinkList.paginationControl && data.locationLinkList.paginationControl.prevLink}
    <link rel="prev" href={data.locationLinkList.paginationControl.prevLink} />
  {/if}
  {#if data.locationLinkList.paginationControl && data.locationLinkList.paginationControl.nextLink}
    <link rel="next" href={data.locationLinkList.paginationControl.nextLink} />
  {/if}
</svelte:head>

<Breadcrumbs crumbsText={data.crumbsText} path={data.breadcrumbPath} paginationPage={data.paginationPage} />
<MastheadSearchPromo {...data.mastheadSearchPromo} filters={`'nationwide' OR '${data.stateName}'`} />
<div class="py-6 md:py-8 mx-auto max-w-6xl lg:flex">
  <LocationLinkList {...data.locationLinkList} locations={data.locations} pageGroup='pharmacy-near-me-chain-state'/>
</div>
<div class="px-4 pb-6 md:pb-8 mx-auto max-w-6xl">
  <DrugSavingsList {...data.drugSavingsList} lang={data.lang} />
</div>
{#if data.extendedPharmaciesList}
  <div class="bg-gray-mercury w-full py-8 lg:py-12 shadow-content-well">
    <ExtendedPharmaciesList {...data.extendedPharmaciesList} count={data.totalCount} pharmacies={data.pharmacies} />
  </div>
{/if}
